import { contractConfigs, poolConfigs } from './components/contractConfigs.js';
import { BigNumber } from '@ethersproject/bignumber';
import { fromAddressTo, fromTokenNameToAddress, tokenNameAddyMap, fromTokenNameToDecimals } from './tokenUtilities.js'
const CHEF = contractConfigs["chef"]["address"]
const CHEFABI = contractConfigs["chef"]["abi"]
const GEN = contractConfigs["generic"]["abi"]

// Pu aka Pool Utilities

export class Pu {
	constructor(web3, ref) {
		this.web3 = web3
		this.ref = ref
		this.dec18 = BigNumber.from(10).pow(18)
	}


	cleanInputAmount (amt, addy) {
		console.log("triggered cleaning" + tokenNameAddyMap.get(addy).name)
		let decNum = fromTokenNameToDecimals(tokenNameAddyMap.get(addy).name)
		console.log(decNum)
		let dec = BigNumber.from(10).pow(decNum)
		let cleanInputAmt = amt.toString();
		
		
		cleanInputAmt = cleanInputAmt.replaceAll(",","")
		cleanInputAmt = Number(cleanInputAmt)
		console.log(cleanInputAmt)
		let inputDecimals = cleanInputAmt % 1;
		let inputNumber = Math.floor(cleanInputAmt - inputDecimals);
		inputDecimals = inputDecimals.toFixed(decNum);
		let inputDecimalsReady = inputDecimals * dec;
		let cleanInput = BigNumber.from(inputNumber);
		console.log(inputDecimalsReady)
		console.log(cleanInput)
		cleanInput = cleanInput.mul(dec).add(inputDecimalsReady.toString());
		return cleanInput;
	}

	approveAmount (addy, callback)  {
		console.log("triggered approval")
		const tract = new this.web3.eth.Contract(GEN, addy);
		let cleanInput = this.cleanInputAmount(this.ref.current.value, addy)
		tract.methods.approve(CHEF, cleanInput)
			.send({from: window.ethereum.selectedAddress})
				.then(callback)

	}

	checkAllowance (addy, callback)  {
		const tract = new this.web3.eth.Contract(GEN, addy);

		console.log("Checking Allowance")

		tract.methods.allowance(window.ethereum.selectedAddress, CHEF)
			.call({from: window.ethereum.selectedAddress})
				.then(callback)

	}


	getBalance (addy, callback) {
		const tract = new this.web3.eth.Contract(GEN, addy);

		console.log("Getting Balance")

		tract.methods.balanceOf(window.ethereum.selectedAddress)
			.call({from: window.ethereum.selectedAddress})
				.then(callback)

	}

	depositAmount (poolId, callback) {
		console.log("triggered deposit " + poolId)
		const tract = new this.web3.eth.Contract(CHEFABI, CHEF);
		let cleanInput = this.cleanInputAmount(this.ref.current.value, fromTokenNameToAddress(poolConfigs[poolId.toString()]["stake-name"]))
		tract.methods.deposit(poolId, cleanInput)
			.send({from: window.ethereum.selectedAddress})
				.then(callback)

	}

	harvest (poolId, callback)  {
		console.log("triggered harvest")
		const tract = new this.web3.eth.Contract(CHEFABI, CHEF);
		tract.methods.deposit(poolId, 0)
			.send({from: window.ethereum.selectedAddress})
				.then(callback)

	}

	withdrawAmount (poolId, callback) {
		console.log("triggered withdraw")
		const tract = new this.web3.eth.Contract(CHEFABI, CHEF);
		let cleanInput = this.cleanInputAmount(this.ref.current.value, fromTokenNameToAddress(poolConfigs[poolId.toString()]["stake-name"]))
		tract.methods.withdraw(poolId, cleanInput)
			.send({from: window.ethereum.selectedAddress})
				.then(callback)
	}

	triggerApproval(addy, callback) {
	
		this.approveAmount(
			addy, 
			() => {
				this.checkAllowance(
					addy, 
					callback
				)
				
			}
		)
				
	}

	getPoolBalance (poolId, callback) {
		const tract = new this.web3.eth.Contract(CHEFABI, CHEF);

		tract.methods.userInfo(poolId, window.ethereum.selectedAddress)
			.call({from: window.ethereum.selectedAddress})
				.then(callback)
	}

	getPoolInfo(poolId, callback) {
		const tract = new this.web3.eth.Contract(CHEFABI, CHEF);

		tract.methods.poolInfo(poolId, window.ethereum.selectedAddress)
			.call({from: window.ethereum.selectedAddress})
				.then(callback)
	}

	getRate(callback) {
		const tract = new this.web3.eth.Contract(CHEFABI, CHEF);
		tract.methods.rewardtokenPerBlock()
			.call({from: window.ethereum.selectedAddress})
					.then(callback)
	}
	getTotalAlloc(callback) {
		const tract = new this.web3.eth.Contract(CHEFABI, CHEF);
		tract.methods.totalAllocPoint()
			.call({from: window.ethereum.selectedAddress})
					.then(callback)
	}

	getPendingRewards (poolId, callback, isRequest) {
		const tract = new this.web3.eth.Contract(CHEFABI, CHEF);
		if (!isRequest) {
			tract.methods.pendingRewards(poolId, window.ethereum.selectedAddress)
				.call({from: window.ethereum.selectedAddress})
					.then(callback)	
		} else {
			return tract.methods.pendingRewards(poolId, window.ethereum.selectedAddress)
						.call.request({from: window.ethereum.selectedAddress}, callback)	
		}
		
	}

}

